import { makeApiRequest } from "../../utils";
import { useMutation } from "@tanstack/react-query";

export const useUploadMedia = () => {
  return useMutation({
    mutationFn: async ({ file }) => {
      const formData = new FormData();
      formData.append("file", file);

      return makeApiRequest({
        endpoint: "/api/upload",
        method: "POST",
        body: formData
      });
    }
  });
};
